import { defineSlotRecipe } from '@chakra-ui/react';
import { pageBg } from '../themeColor';
import { pressActive } from './press';

const checkedFill = {
  bg: 'accent',
  borderColor: 'accent',
  color: 'bg',
} as const;

const overlayHalo = `0 1px 3px rgba(0, 0, 0, 0.28), 0 0 0 1px ${pageBg(0.35)}`;

/** Checked gold and the card-art overlay. `tone` on the checkbox selects the variant. */
export const checkboxSlotRecipe = defineSlotRecipe({
  slots: ['root', 'control', 'label'],
  base: {
    root: {
      _active: pressActive,
    },
    control: {
      borderWidth: '1.5px',
      borderRadius: 'full',
      overflow: 'hidden',
      color: 'bg',
      p: '0.5',
      _hover: { borderColor: 'accentMuted' },
      _checked: checkedFill,
    },
  },
  variants: {
    variant: {
      default: {
        control: {
          bg: 'surface',
          borderColor: 'border',
          boxShadow: 'xs',
          _checked: { ...checkedFill, boxShadow: 'xs' },
        },
      },
      overlay: {
        control: {
          bg: 'bg',
          borderColor: 'text',
          boxShadow: overlayHalo,
          _checked: { ...checkedFill, boxShadow: overlayHalo },
        },
      },
    },
  },
});
